import type { FC } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import { Button } from "~/shared/ui-kit";
import { Container } from "~/shared/ui-kit/container/Container";
import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Title } from "~/shared/ui-kit/title/Title";

import type { CardGalleryProps } from "../CardGallery";
import { RowCard } from "./RowCard";

export const Row: FC<CardGalleryProps> = (props) => {
  const { data, getUrl, isControlInactive, onCallAction } = props;
  const controlAction = data?.action;
  const isInactive = controlAction ? isControlInactive(controlAction) : true;
  const action = data.action?.action?.[0];
  const isUseSwiper = (data?.cards?.length ?? 0) > 3;
  let href;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }
  const handlePressButton = (): void => {
    if (action) {
      onCallAction(action);
    }
  };
  return (
    <Container
      as="section"
      className="max-w-[1240px] mx-auto py-8 lg:py-16"
      flexDirection="column"
    >
      <Flex
        flexDirection="column"
        align="flex-start"
        justify="center"
        d={{
          flexDirection: action ? "row" : "column",
          justify: action ? "space-between" : "center",
        }}
        className="mb-6 lg:mb-16"
      >
        <Title
          as="h2"
          size="medium"
          weight="semibold"
          className="text-center m-0"
        >
          {data.title}
        </Title>
        {!isInactive && (
          <Button
            size="small"
            weight="bold"
            onPress={handlePressButton}
            href={href}
            className="hidden lg:block py-3 px-6"
          >
            {data.action_text}
          </Button>
        )}
      </Flex>

      {isUseSwiper ? (
        <Flex gap={20}>
          <Swiper
            spaceBetween={20}
            grabCursor
            breakpoints={{
              1024: { slidesPerView: 3 },
              768: { slidesPerView: 2 },
              340: {
                slidesPerView: 1,
                centeredSlides: true,
              },
            }}
          >
            {data?.cards?.map((card) => (
              <SwiperSlide key={card?.id}>
                <Flex
                  justify="center"
                  align="center"
                  md={{ flexDirection: "row", align: "stretch" }}
                  className="h-full"
                >
                  {card && <RowCard key={card.id} {...props} card={card} />}
                </Flex>
              </SwiperSlide>
            ))}
          </Swiper>
        </Flex>
      ) : (
        <Flex
          md={{
            justify: "center",
            flexDirection: "row",
            align: "stretch",
            gap: 20,
          }}
          justify="center"
          flexDirection="column"
          align="center"
          gap={24}
          className="flex-wrap"
        >
          {data?.cards?.map(
            (card) => card && <RowCard key={card?.id} {...props} card={card} />,
          )}
        </Flex>
      )}

      {!isInactive && (
        <Flex
          align="center"
          justify="center"
          className="lg:hidden mt-6 md:mt-12"
        >
          <Button
            onPress={handlePressButton}
            href={href}
            size="small"
            weight="bold"
            className="py-2.5 px-11 max-w-[148px] text-nowrap max-h-10"
          >
            {data.action_text}
          </Button>
        </Flex>
      )}
    </Container>
  );
};
